
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/presave/spotify",
      function () {
        return require("private-next-pages/presave/spotify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/presave/spotify"])
      });
    }
  